
import { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoadingScreen from './components/loading/index.jsx';
import LandingPage from './components/pages/landing/index.jsx';
import AboutPage from './components/pages/about/index.jsx';
import StoryPage from './components/pages/story/index.jsx';
import PortfolioPage from './components/pages/portfolio/index.jsx';
import TeamPage from './components/pages/team/index.jsx';

function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && <LoadingScreen onFinish={() => setLoaded(true)} />}

      <BrowserRouter>
        <Routes>
          <Route path="/"          element={<LandingPage />} />
          <Route path="/about"     element={<AboutPage />} />
          <Route path="/story"     element={<StoryPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/team"      element={<TeamPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
